























import Vue from 'vue'
import OneComment from './OneComment.vue'
import ReplyList from './ReplyList.vue'

export default Vue.extend({
  data() {
    return {
      stateComment: {},
      showReplyList: true
    }
  },
  components: {
    OneComment,
    ReplyList,
  },
  props: {
    comment: {
        type: Object
    },
    instructor: {
        type: Object
    },
    commentPermission: {
        type: String
    },
    pendoPayload: {
      type: Object
    },
    productCommentPrivacy: {
      type: String
    }
  },
  methods: {
    updateStateParentComment(params) {
      this.stateComment.content = params.content
      this.stateComment.visibility = params.visibility
    },
    replyComment(params) {
      this.$bus.$emit('replyComment', params)
    },
    hideReplyList(status: boolean) {
      this.showReplyList = status
    }
  },
  mounted() {
    this.stateComment = this.comment
  }
})
